import { EventEmitter, Injectable } from "@angular/core";
import { Employee } from "../_interfaces/employee";
import * as Quill  from 'quill';
import { ArrowKeysOptions } from "../_directives/ArrowKeysUseable.directive";
import { TicketEditService } from "./ticket-edit.service";

export interface UserInformationPopover{
  active: boolean, 
  animation?: boolean,
  employee?: Employee,
  x?: number, 
  y?: number
}

// let Inline = Quill.import('blots/inline');
// export class Userselect extends Inline {  
//   static create(value){
//       let node = super.create();
//       node.setAttribute('class','userselect');
//       return node;    
//   }
// }

// const Embed = Quill.import("blots/embed");
// export class Userselected extends Embed {  
//   static create(data){
//       let node = super.create( data.denotationChar);

//       node.setAttribute('class',`userselected userid-${data.userId}`);
//       node.setAttribute("userid", data.userId)
//       node.setAttribute("href", data.userEmail)
//       node.setAttribute("data-value", data.denotationChar);

//       node.addEventListener("DOMNodeRemoved", (e)=>{
//         if(e.target.nodeType == 1) if(data.onRemoved) data.onRemoved(data.userId)
//       })

//       node.innerHTML = data.denotationChar

//       return node; 
//   }

//   static value(domNode) {
//     return {
//       denotationChar: domNode.getAttribute("data-value"),
//       userEmail: domNode.getAttribute("href"),
//       userId: domNode.getAttribute("userId")
//     }
// 	}

// }

export interface QuillMentionItem{
    id: number, 
    value: string 
    denotationChar?: string 
}

export class UserselectService {

//   public editor: any
//   public isOnUserSelect: boolean = false
//   public filteredUserList: Employee[] = []
//   public userlistPosition: {x: number, y: number} = null

//   public addedEmployees: {count: number, employee: Employee}[] = []
//   private cursorPosition: number = 0

//   private isMobile: boolean

//   private ticketEditSrv: TicketEditService

//   public arrowKeysOptions: ArrowKeysOptions = {
//     mouseMove: new EventEmitter<boolean>(null),
//     mouseOverItem: new EventEmitter<number>(null),
//     clearSelectedItem: new EventEmitter<boolean>(null),
//     enterPressed: ()=>{},
//     selectedItem: -1
//   }

    private employees: Employee[] = []
    private selectedItems: QuillMentionItem[] = []

    public get selectedEmployees(): Employee[]{
        return this.selectedItems.map(i => this.employees.find(e => e.id == i.id))
    }


    constructor(
        private employeeList: Employee[],
    ) {  
        this.employees = JSON.parse(JSON.stringify(this.employeeList))
    }

    /**
     * Gibt liste der Benutzer zurück anhand des Suchtextes
     * @param {string} searchText suchtext nachdem gefiltert werden soll
     * @param {({id: number, value: string}[]) => void} renderList funktion zum rendern der Liste mit übergebenen Benutzern
     */
    public async renderUserList(searchText: string, renderList: (matchedEmployees: QuillMentionItem[]) => void) {
        const filteredEmployees: Employee[]  = this.employees.filter(e => e.firstName.toLowerCase().includes(searchText) || e.lastName.toLowerCase().includes(searchText) )
        renderList(filteredEmployees.map(e => ({id: e.id, value: `${e.firstName} ${e.lastName}`})))
    }

    /**
     * fügt item zu den ausgewählten items hinzu wenn es noch nicht drin ist
     * @param {QuillMentionItem} item item das ausgewählt wurde
     * @param {(item: QuillMentionItem) => void} insertItem funktion zum Einfügen des items
     * @returns 
     */
    public async onSelectUser(item: QuillMentionItem, insertItem: (item: QuillMentionItem) => void) {
        insertItem(item)
        if(!!this.selectedItems.find(i => i.id == item.id)) return
        this.selectedItems.push(item)
    }


//   /**
//    * hört auf den keydown der im Constructor übergebenen Quill-Editor-referenz
//    */
//   private listenToKeyDown(){
//     this.editor.root.addEventListener("keydown", (e: KeyboardEvent)=>{

//       //position des Cursors
//       this.cursorPosition = this.editor.getSelection().index as number;

//       //Verbieten in editor mit Pfeiltasten zu navigieren wenn userselect mode
//       if((e.key == "ArrowUp" || e.key == "ArrowDown") && this.isOnUserSelect) return e.preventDefault()

//       //Fügt embedet element dem Edior hinzu bei Enter
//       if(this.checkKeyDownIsEnter(false, e.key)) return

//       //Neue userselect "session" starten wenn @ gedrückt wurde
//       if(e.key !== "@") return        
//       this.handleAtPressed(this.cursorPosition)

//     })
//   }


//     /**
//    * Fügt embedet element dem Edior hinzu wenn enter gedrückt wurde und gearde inUserSelect-Modus ist 
//    * @param {string} key Keyname der gedrückten Taste
//    * @param {number} range Position des cursors
//    * @returns 
//    */
//      public checkKeyDownIsEnter(isClick: boolean, key?: string){
//       if(((key == "Enter") || isClick) && this.isOnUserSelect){
//         this.editor.blur()
//         if(this.arrowKeysOptions.selectedItem == -1){
//           if(this.filteredUserList[0]) this.arrowKeysOptions.selectedItem = 0
//           else {
//             this.editor.setSelection(this.cursorPosition)
//             return
//           }
          
//         }
        
//         const selectedUser: Employee = this.filteredUserList[this.arrowKeysOptions.selectedItem];
//         if(!selectedUser) return
//         let userElement = this.editor.root.getElementsByClassName("userselect")[0]
//         this.arrowKeysOptions.clearSelectedItem.next(null)
//         this.arrowKeysOptions.selectedItem = -1
//         const userInsertedTextLength: number = userElement?.innerText?.length 
//         userElement?.remove()
//         this.isOnUserSelect = false
  
//         this.editor.insertEmbed( this.cursorPosition - userInsertedTextLength,  "userselected", {
//           denotationChar: `@${selectedUser.firstName} ${selectedUser.lastName}`,
//           userId: selectedUser.id,
//           userEmail: selectedUser?.eMail ? `mailto:${selectedUser.eMail}` : `mailto:${selectedUser.telefone || ""}`,
//           onRemoved: (userId: number) => this.addedEmployees.find(e => e.employee.id == userId).count--
//         }, Quill.sources.API);

//         //Zu array hinzufügen um zu wissen wer und wie oft hinzugefügt wurde
//         let employeeObj: {count: number, employee: Employee} = this.addedEmployees.find(e => e.employee.id == selectedUser.id)
//         if(employeeObj)employeeObj.count++
//         else this.addedEmployees.push({
//           count: 1,
//           employee: selectedUser
//         })

        
//         this.editor.insertText(this.cursorPosition - userInsertedTextLength + 1 , " ", "user" )
//         this.editor.setSelection(this.cursorPosition + 1)
//         return true
//       }
//       return false
//     }

//      /**
//    * Fügt neues Userselect element hinzu bei der Eingabe vvon @
//    * @param {number} range Position des cursors
//    */
//   public handleAtPressed(range: number){

//     //Ohne timeout funktioniert es nicht warum auch immer
//     setTimeout( () => {
//       const charBefore: string = this.editor.getText(range - 1, 1) 
//       if(charBefore != " " && charBefore != "") return
      
//       this.editor.formatText(range, 1, "userselect", true)
      
//       let userListKeyElement = this.editor.root.getElementsByClassName("userselect")[0]
//       let pos = userListKeyElement?.getBoundingClientRect()
//       if(!pos) return

//       let editorPos = this.editor.root.getBoundingClientRect()

//       this.filteredUserList = Object.assign([], this.ticketEditSrv.employees)
      
//       this.isOnUserSelect = true

//       this.userlistPosition = {
//         y: pos.top - editorPos.top + pos.height + (this.isMobile ? 5 : 0),
//         x: pos.left - editorPos.left
//       }

//       userListKeyElement.addEventListener("DOMNodeRemoved", (e)=>this.handleRemovesdUserlist(e))
//       userListKeyElement.addEventListener("DOMCharacterDataModified", (e)=>this.userListSearchModified(e))
//     }, this.isMobile ? 20 : 0);
//   }

//   /**
//    * entfernt im schreibmode das element wenn es gelöscht wurde
//    * @param {any} event element welches entfernt wurde
//    * @returns 
//    */
//   private handleRemovesdUserlist(event: any){
//     this.userlistPosition = null
//     this.arrowKeysOptions.clearSelectedItem.next(null)
//     this.arrowKeysOptions.selectedItem = -1
//   }

//   /**
//    * Updatet userfilterlist wenn etwas geschrieben wurde 
//    * @param {any} event element welches bearbeitet wurde
//    */
//   private userListSearchModified(event: any){
//     this.arrowKeysOptions.clearSelectedItem.next(null)
//     this.arrowKeysOptions.selectedItem = -1
//     const newValue: string = event.newValue.substring(1).toLowerCase()
//     this.filteredUserList = this.ticketEditSrv.employees.filter(e => e.firstName.toLowerCase().includes(newValue) || e.lastName.toLowerCase().includes(newValue) )
//   }









}
